/* eslint-disable eqeqeq */
import React from 'react';

import { Theme } from '../styles/select-theme';
import { col } from '../styles/colors';

import { 
	FaCoins,
	//FaSyncAlt as RISync,
	FaCircle,
//	FaCopy,
	FaEthereum,
	FaBitcoin,
	FaCloudUploadAlt,
	FaAffiliatetheme as RIReferral,
	FaKey as RIKeys,
	FaWallet as RIWallet,
	FaQuestionCircle as RIQuestion,
} from 'react-icons/fa';

import {
	//GrCode as RICode,
} from 'react-icons/gr';

import {
	//VscSync as RISync,
	//VscHistory as RIHistory,
	//VscListFlat as RIOrderbook,
} from 'react-icons/vsc';

import {
	//AiOutlineSync as RISync,
	AiOutlineLineChart as RIChart,
	AiOutlineFileDone as RITrades,
	AiOutlineFileAdd as RINewOrder,
	//AiOutlineDownload as RIDownload,
} from 'react-icons/ai';

import {
	//GoSync as RISync,
} from 'react-icons/go';

import {
	//BiSync as RISync,
	//BiLogIn as RILogin,
} from 'react-icons/bi';

import {
	//MdSync as RISync,
	MdHistory as RIHistory,
	//MdAccountBalance as RIAccount,
	MdFormatLineSpacing as RIOrderbook,
	MdSecurity as RISecurity,
} from 'react-icons/md';

import {
	IoMdSync as RISync,
	//IoMdDownload as RIDownload,
	IoMdPause as RIPause,
	//IoIosLogIn as RILogin,
} from 'react-icons/io';

import {
	//RiLayoutMasonryLine as RILayout,
	RiBankCard2Line as RIAccount,
	RiBankCardLine as RIAccounts,
	RiFileListLine as RIAllTrades,
	RiStopFill as RIStop,
	RiFileList2Line as RIInstrument,
	RiCodeSSlashLine as RICode,
} from 'react-icons/ri';

import {
	BsLayoutWtf as RILayout,
	BsPlayFill as RIPlay,
	//BsPause as RIPause,
	//BsDownload as RIDownload,
} from 'react-icons/bs';

import {
	//ImPause2 as RIPause,
} from 'react-icons/im';

import {
//	GiThreeKeys as RIKeys,
} from 'react-icons/gi';

import {
	FiLogIn as RILogin,
} from 'react-icons/fi';

export function IViking(props) {
	let size = props.size ? props.size : "29";
	return <svg className={props.className} width={size} height={size} viewBox="0 0 29 36" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fillRule="evenodd" clipRule="evenodd" d="M10.4081 0V9.42857L18.9796 18L10.4081 26.5714V36L28.4081 18L10.4081 0ZM10.4081 12.6124V23.3879L15.6734 18.0001L10.4081 12.6124ZM8.08163 10.4082V26.449L0 18.3674L8.08163 10.4082Z" fill={props.color ? props.color : "#35B6FF"}/>
	</svg>
}

export function IVikingWhite(props) {
	let size = props.size ? props.size : "29";
	return <svg className={props.className} width={size} height={size} viewBox="0 0 29 36" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fillRule="evenodd" clipRule="evenodd" d="M10.4081 0V9.42857L18.9796 18L10.4081 26.5714V36L28.4081 18L10.4081 0ZM10.4081 12.6124V23.3879L15.6734 18.0001L10.4081 12.6124ZM8.08163 10.4082V26.449L0 18.3674L8.08163 10.4082Z" fill={Theme.current === "light" ? "#DFE2E6" : "#bfc1c4"}/>
	</svg>
}

export function IBtnCopyClipboard(props) {
	//let stroke = Theme.current === "light" ? col.white : col.grey;
	let stroke = col.white;
	return <svg width={props.size} height={props.size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M4 15L13 15C14.1046 15 15 14.1046 15 13L15 4C15 2.89543 14.1046 2 13 2L4 2C2.89543 2 2 2.89543 2 4L2 13C2 14.1046 2.89543 15 4 15Z" stroke={stroke} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M19 9L20 9C20.5304 9 21.0391 9.21071 21.4142 9.58579C21.7893 9.96086 22 10.4696 22 11L22 20C22 20.5304 21.7893 21.0391 21.4142 21.4142C21.0391 21.7893 20.5304 22 20 22L11 22C10.4696 22 9.96086 21.7893 9.58579 21.4142C9.21071 21.0391 9 20.5304 9 20L9 19" stroke={stroke} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>;
}

export function IBtnCross(props) {
	//let stroke = Theme.current === "light" ? col.white : col.grey;
	let stroke = col.white;
	return <svg width={props.size} height={props.size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M18 6L6 18" stroke={stroke} strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M6 6L18 18" stroke={stroke} strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
}

export function IChevronRight(props) {
	//let stroke = Theme.current === "light" ? col.grey : col.grey_light;
	let stroke = Theme.current === "light" ? col.grey_40 : col.grey_10;
	return <svg width={props.size} height={props.size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M9 18L15 12L9 6" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
}

export function IChevronLeft(props) {
	//let stroke = props.color ? props.color : (Theme.current === "light" ? col.grey : col.grey_light);
	let stroke = col.grey_light;
	return <svg width={props.size} height={props.size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M15 6L9 12L15 18" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
}

export function IChevronUp(props) {
	let stroke = Theme.current === "light" ? col.grey : col.grey_light;
	return <svg width={props.size} height={props.size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M18 15L12 9L6 15" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
}

export function IChevronDown(props) {
	let stroke = Theme.current === "light" ? col.grey_40 : col.grey_10;
	return <svg width={props.size} height={props.size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M6 9L12 15L18 9" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
}

export function IArrowUp() {
	//let stroke = Theme.current === "light" ? col.white : col.grey;
	let stroke = col.white;
	return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M12 19V5" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M5 12L12 5L19 12" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
}

export function IArrowDown() {
	//let stroke = Theme.current === "light" ? col.white : col.grey;
	let stroke = col.white;
	return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M12 5L12 19" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M19 12L12 19L5 12" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
}

export function ISelectTriangle() {
	let stroke = Theme.current === "light" ? col.night_sky : col.grey_light;
	return <svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M4.71784 5.29996C4.56163 5.45617 4.30837 5.45617 4.15216 5.29996L0.117843 1.26564C-0.134142 1.01365 0.0443243 0.582799 0.400687 0.582799L8.46932 0.582799C8.82568 0.582799 9.00414 1.01366 8.75216 1.26564L4.71784 5.29996Z" fill={stroke}/>
	</svg>
}

export function ICheck(props) {	
	//return <RICheck size="20px" color="white"/>;
	/*return <svg width={props.size} height={props.size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M20 6L9 17L4 12" stroke={props.color} strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>*/

	return <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M17 1L6 12L1 7" stroke={props.color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
}

export function ICopy() {
	return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M4 15L13 15C14.1046 15 15 14.1046 15 13L15 4C15 2.89543 14.1046 2 13 2L4 2C2.89543 2 2 2.89543 2 4L2 13C2 14.1046 2.89543 15 4 15Z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M19 9L20 9C20.5304 9 21.0391 9.21071 21.4142 9.58579C21.7893 9.96086 22 10.4696 22 11L22 20C22 20.5304 21.7893 21.0391 21.4142 21.4142C21.0391 21.7893 20.5304 22 20 22L11 22C10.4696 22 9.96086 21.7893 9.58579 21.4142C9.21071 21.0391 9 20.5304 9 20L9 19" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
}

export function IUser() {
	return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
}

export function IMenu() {
	return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M3 12H21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M3 6H21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M3 18H21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
}

export function IBell() {
	return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M18 7.99997C18 6.40867 17.3679 4.88255 16.2426 3.75733C15.1174 2.63211 13.5913 1.99997 12 1.99997C10.4087 1.99997 8.88258 2.63211 7.75736 3.75733C6.63214 4.88255 6 6.40867 6 7.99997C6 15 3 17 3 17H21C21 17 18 15 18 7.99997Z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
}

export function IPlus(props) {
	let stroke = Theme.current === "light" ? col.grey : col.grey_light;
	return <svg width={props.size} height={props.size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M12 5V19" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M5 12H19" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
}

/*export function IBtnCross () {
	return <svg width="17" height="17" viewBox="0 0 24 24">
	  <rect x="0" y="0" rx="8" ry="8" width="24" height="24" style="fill:red;" />
	  <path d="M18 6L6 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	  <path d="M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
}*/

export function ICross() {
	let stroke = Theme.current === "light" ? col.grey : col.grey_light;
	return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M18 6L6 18" stroke={stroke} strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M6 6L18 18" stroke={stroke} strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
}

export function ISettings(props) {
	let stroke = Theme.current === "light" ? col.grey : col.grey_light;
	return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke={stroke} strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15V15Z" stroke={stroke} strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
}

export function IQuotes(props) {
	//let stroke = props.color ? props.color : (Theme.current === "light" ? col.grey_5 : col.grey_light);
	return <svg width={props.size} height={props.size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M33 24.15V10.5H19.35L23.85 15L15 23.85L19.5 28.5L28.5 19.5L33 24.15Z" stroke={props.color} strokeWidth="2.1" strokeMiterlimit="10" strokeLinejoin="round"/>
		<path d="M15 23.85V37.5H28.65L24.15 33L33 24.15L28.5 19.5L19.5 28.5L15 23.85Z" stroke={props.color} strokeWidth="2.1" strokeMiterlimit="10" strokeLinejoin="round"/>
	</svg>
}

export function IIndexes(props) {
	//let stroke = Theme.current === "light" ? col.grey_5 : col.grey_light;
	return <svg width={props.size} height={props.size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M34.8003 23.7C33.9003 23.85 33.0003 23.25 32.5503 22.35C32.4003 22.05 32.1003 21.75 31.6503 21.75H29.8503C29.5503 21.75 29.1003 21.9 28.9503 22.35C28.5003 23.25 27.6003 23.7 26.7003 23.7C26.4003 23.7 25.9503 23.85 25.8003 24.15L24.9003 25.8C24.7503 26.1 24.7503 26.55 24.9003 26.85C25.5003 27.6 25.5003 28.65 24.9003 29.4C24.7503 29.7 24.6003 30.15 24.9003 30.45L25.8003 32.1C25.9503 32.4 26.4003 32.55 26.7003 32.55C27.6003 32.4 28.5003 33 28.9503 33.9C29.1003 34.2 29.4003 34.5 29.8503 34.5H31.6503C31.9503 34.5 32.4003 34.35 32.5503 33.9C33.0003 33 33.9003 32.55 34.8003 32.55C35.1003 32.55 35.5503 32.4 35.7003 32.1L36.6003 30.45C36.7503 30.15 36.7503 29.7 36.6003 29.4C36.0003 28.65 36.0003 27.6 36.6003 26.85C36.7503 26.55 36.9003 26.1 36.6003 25.8L35.7003 24.15C35.5503 23.85 35.1003 23.7 34.8003 23.7Z" stroke={props.color} strokeWidth="2.1" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M13.3496 26.85V34.35" stroke={props.color} strokeWidth="2.1" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M19.8 31.35V34.35" stroke={props.color} strokeWidth="2.1" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M13.3496 19.35L19.3496 23.7L25.3496 17.85L31.3496 15.6" stroke={props.color} strokeWidth="2.1" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M31.3499 17.55C32.4269 17.55 33.2999 16.6769 33.2999 15.6C33.2999 14.523 32.4269 13.65 31.3499 13.65C30.2729 13.65 29.3999 14.523 29.3999 15.6C29.3999 16.6769 30.2729 17.55 31.3499 17.55Z" fill={props.color}/>
		<path d="M25.3499 19.8C26.4269 19.8 27.2999 18.9269 27.2999 17.85C27.2999 16.773 26.4269 15.9 25.3499 15.9C24.2729 15.9 23.3999 16.773 23.3999 17.85C23.3999 18.9269 24.2729 19.8 25.3499 19.8Z" fill={props.color}/>
		<path d="M19.3499 25.65C20.4269 25.65 21.2999 24.777 21.2999 23.7C21.2999 22.623 20.4269 21.75 19.3499 21.75C18.2729 21.75 17.3999 22.623 17.3999 23.7C17.3999 24.777 18.2729 25.65 19.3499 25.65Z" fill={props.color}/>
		<path d="M13.3499 21.3C14.4269 21.3 15.2999 20.4269 15.2999 19.35C15.2999 18.273 14.4269 17.4 13.3499 17.4C12.2729 17.4 11.3999 18.273 11.3999 19.35C11.3999 20.4269 12.2729 21.3 13.3499 21.3Z" fill={props.color}/>
	</svg>
}

export function IBtnRefresh(props) {
	return <RISync size={props.size ? props.size : 20} color={props.color}/>;
}

export function IRefresh(props) {
	//return <RISync size={props.size ? props.size : 20} color={props.color}/>;
	let stroke = Theme.current === "light" ? col.grey : col.grey_light;
	return <div style={{margin: "3px"}}><svg width="14" height="14" x="0" y="0" viewBox="0 0 16.960917 20.797087" fill="none" xmlns="http://www.w3.org/2000/svg">
	  <path
     d="M 15.804174,14.159584 C 18.487353,7.666047 12.602927,0.69153572 4.8509127,3.6628455"
	     stroke={stroke}
       strokeWidth="1.2"
	     strokeLinecap="round"
	     strokeLinejoin="round"/>
	  <path
     d="M 7.6674392,6.1929344 4.8509127,3.6628455"
	     stroke={stroke}
       strokeWidth="1.2"
	     strokeLinecap="round"
	     strokeLinejoin="round"/>
	  <path
     d="M 6.6684283,0.5 4.8509127,3.6628455"
	     stroke={stroke}
       strokeWidth="1.2"
	     strokeLinecap="round"
	     strokeLinejoin="round"/>
	  <g transform="rotate(180,7.9113945,13.963915)">
    <path
       d="M 14.666046,20.764513 C 17.349225,14.270976 11.464799,7.2964645 3.7127841,10.267774"
       stroke={stroke}
       strokeWidth="1.2"
       strokeLinecap="round"
       strokeLinejoin="round"/>
    <path
       d="M 6.6314598,12.612217 3.7127841,10.267774"
       stroke={stroke}
       strokeWidth="1.2"
       strokeLinecap="round"
       strokeLinejoin="round"/>
    <path
       d="M 5.5390696,6.6878092 3.7127841,10.267774"
       stroke={stroke}
       strokeWidth="1.2"
       strokeLinecap="round"
       strokeLinejoin="round"/>
    </g>
  </svg></div>	
}

export function IDownload(props) {
	let stroke = Theme.current === "light" ? col.grey : col.grey_light;
	return <div style={{margin: "1px"}}><svg width="18" height="18" x="0" y="0" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
     d="M 12,3 V 17"
     stroke={stroke}
     strokeWidth="1.1"
     strokeLinecap="round"
     strokeLinejoin="round"
     />
  <path
     d="M 18.011513,12.223478 12,17 5.9884865,12.223478"
     stroke={stroke}
     strokeWidth="1.1"
     strokeLinecap="round"
     strokeLinejoin="round"
     />
  <path
     d="m 20.724308,20.132782 -17.3885865,0.0062"
     stroke={stroke}
     strokeWidth="1.1"
     strokeLinecap="round"
     strokeLinejoin="round"
     
     /></svg></div>
}

export function IPlay(props) {
	return <RIPlay size={props.size ? props.size : 20} color={props.color}/>;
}

export function IPause(props) {
	return <RIPause size={props.size ? props.size : 20} color={props.color}/>;
}

export function IStop(props) {
	return <RIStop size={props.size ? props.size : 20} color={props.color}/>;
}

export function ICloudUpload(props) {
	return <FaCloudUploadAlt size={props.size} color={props.color}/>;
}

export function IBTC(props) {
	return <FaBitcoin size={props.size} color="#F7931A"/>;
}

export function IETH(props) {
	return <FaEthereum size={props.size}/>;
}

export function ICircle(props) {
	return <FaCircle size={props.size} style={props.style} color={props.color}/>;
}

export function ICoins(props) {
	return <FaCoins size={props.size} color={props.color}/>;
}

export function IKeys(props) {
	//14 20
	return <div style={{margin: (props.size == 48 ? 14 : 11) + "px"}}><RIKeys size={(props.size == 48 ? 20 : 14) + "px"} color={props.color}/></div>;
}

export function IWallet(props) {
	//14 20
	return <div style={{margin: (props.size == 48 ? 14 : 11) + "px"}}><RIWallet size={(props.size == 48 ? 20 : 14) + "px"} color={props.color}/></div>;
}

export function IQuestion(props) {
	//14 20
	return <div style={{margin: (props.size == 48 ? 14 : 11) + "px"}}><RIQuestion size={(props.size == 48 ? 20 : 14) + "px"} color={props.color}/></div>;
}

export function ISecurity(props) {
	//12 24
	return <div style={{margin: (props.size == 48 ? 12 : 9) + "px"}}><RISecurity size={(props.size == 48 ? 24 : 18) + "px"} color={props.color}/></div>;
}


export function IReferral(props) {
	//12 24
	return <div style={{margin: (props.size == 48 ? 12 : 10) + "px"}}><RIReferral size={(props.size == 48 ? 24 : 16) + "px"} color={props.color}/></div>;
}

export function IAccount(props) {
	let margin = 11;
	//11 26
	return <div style={{margin: margin + "px"}}><RIAccount size={props.size - 2 * margin + "px"} color={props.color}/></div>;
}

export function IAccounts(props) {
	let margin = 11;
	//11 26
	return <div style={{margin: margin + "px"}}><RIAccounts size={props.size - 2 * margin + "px"} color={props.color}/></div>;
}


export function IOrderbook(props) {
	let margin = 9;
	//9 30
	return <div style={{margin: margin + "px"}}><RIOrderbook size={props.size - 2 * margin + "px"} color={props.color}/></div>;
}

export function ILayout(props) {
	let margin = 9;
	//9 30
	return <div style={{margin: margin + "px"}}><RILayout size={props.size - 2 * margin + "px"} color={props.color}/></div>;
}

export function IHistory(props) {
	let margin = 9;
	//9 30
	return <div style={{margin: margin + "px"}}><RIHistory size={props.size - 2 * margin + "px"} color={props.color}/></div>;
}

export function IChart(props) {
	let margin = 9;
	//9 30
	return <div style={{margin: margin + "px"}}><RIChart size={props.size - 2 * margin + "px"} color={props.color}/></div>;
}

export function ICode(props) {
	let margin = 9;
	//9 30
	return <div style={{margin: margin + "px"}}><RICode size={props.size - 2 * margin + "px"} color={props.color}/></div>;
}

export function ITrades(props) {
	//let stroke = Theme.current === "light" ? col.grey_5 : col.grey_light;
	let margin = 9;
	//9 30
	return <div style={{margin: margin + "px"}}><RITrades size={props.size - 2 * margin + "px"} color={props.color}/></div>;
}

export function INewOrder(props) {
	//let stroke = Theme.current === "light" ? col.grey_5 : col.grey_light;
	let margin = 9;
	//9 30
	return <div style={{margin: margin + "px"}}><RINewOrder size={props.size - 2 * margin + "px"} color={props.color}/></div>;
}

export function IAllTrades(props) {	
	//9 30
	let margin = 9;
	return <div style={{margin: margin + "px"}}><RIAllTrades size={props.size - 2 * margin + "px"} color={props.color}/></div>;
}

export function IInstrument(props) {	
	//9 30
	let margin = 9;
	return <div style={{margin: margin + "px"}}><RIInstrument size={props.size - 2 * margin + "px"} color={props.color}/></div>;
}

export function IEmpty(props) {
	return <svg width={props.size} height={props.size}>
		</svg>
}

export function ILogin(props) {	
	return <RILogin size="20px" color="white"/>;
}
